module.exports = __webpack_public_path__ + "ed48733114fd273a78a9c495ad6132cb.png";